import React from "react";
import { ErrorToasterContainer, ToasterContainer } from "./toaster-styles";

import "react-toastify/dist/ReactToastify.css";

export const Toaster = () => <ToasterContainer />;

export const ErrorToast = () => <ErrorToasterContainer />;
